// src/services/orderService.js
import api from './api';

const orderService = {
  /**
   * Create new order
   * @param {Object} orderData - { addressId, paymentMethod, notes }
   * @returns {Promise<Object>} Razorpay order details or Order confirmation
   * 
   * For RAZORPAY:
   * Returns: { razorpayOrderId, currency, amount, razorpayKeyId, orderNumber }
   * 
   * For COD:
   * Returns: Complete order object with CONFIRMED status
   */
  createOrder: async (orderData) => {
    const response = await api.post('/orders/create', orderData);
    return response.data;
  },

  /**
   * Verify Razorpay payment
   * @param {Object} paymentData - { razorpayOrderId, razorpayPaymentId, razorpaySignature }
   * @returns {Promise<Object>} Confirmed order
   */
  verifyPayment: async (paymentData) => {
    const response = await api.post('/orders/verify-payment', paymentData);
    return response.data;
  },

  /**
   * Get user's order history
   * @returns {Promise<Array>} List of orders
   */
  getUserOrders: async () => {
    const response = await api.get('/orders');
    return response.data;
  },

  /**
   * Get order by ID
   * @param {number} orderId - Order ID
   * @returns {Promise<Object>} Order details
   */
  getOrderById: async (orderId) => {
    const response = await api.get(`/orders/${orderId}`);
    return response.data;
  },

  /**
   * Get order by order number
   * @param {string} orderNumber - Order number (e.g., VT1234567890)
   * @returns {Promise<Object>} Order details
   */
  getOrderByNumber: async (orderNumber) => {
    const response = await api.get(`/orders/number/${orderNumber}`);
    return response.data;
  },

  /**
   * Cancel order
   * @param {number} orderId - Order ID
   * @returns {Promise<Object>} Success message
   */
  cancelOrder: async (orderId) => {
    const response = await api.put(`/orders/${orderId}/cancel`);
    return response.data;
  },

  // --- Admin-only methods ---

  adminGetAllOrders: async () => {
    const response = await api.get('/admin/orders');
    return response.data;
  },

  adminGetOrder: async (orderId) => {
    const response = await api.get(`/admin/orders/${orderId}`);
    return response.data;
  },

  adminUpdateOrder: async (orderId, data) => {
    const response = await api.patch(`/admin/orders/${orderId}`, data);
    return response.data;
  },
};

export default orderService;